var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "UiFocusContainer",
    {
      ref: "focusContainer",
      staticClass: "ui-popover",
      class: { "is-raised": _vm.raised },
      attrs: {
        role: "dialog",
        "contain-focus": _vm.containFocus,
        "focus-redirector": _vm.focusRedirector,
      },
      on: {
        "focus-overflow": function ($event) {
          return _vm.close()
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }